/* Надходження пацієнтів (/arrivals): alerts to the doctors on duty when a walk-in is registered to a generic doctor. */
export const arrivalsUk = {
  'nav.arrivals': 'Надходження пацієнтів',
  'arrivals.subtitle': 'Пацієнта без запису зареєстрували на «Черговий лікар» — лікарі на зміні отримують сповіщення і натискають «Беру»',
  'arrivals.tabLog': 'Журнал',
  'arrivals.tabStats': 'Час реакції',
  'arrivals.tabSettings': 'Налаштування',
  'arrivals.tabPreview': 'Прогноз',
  'arrivals.offBanner': 'Сповіщення вимкнені для всіх філій. Увімкніть філію в «Налаштуваннях» (спочатку — тіньовий режим).',
  'arrivals.shadowBadge': 'Тіньовий',
  'arrivals.empty': 'Надходжень за період немає',
  'arrivals.days': 'Період',
  'arrivals.daysN': '{n} дн.',
  'arrivals.allBranches': 'Усі філії',
  'arrivals.onlyOpen': 'Лише не взяті',
  'arrivals.colTime': 'Час',
  'arrivals.colPatient': 'Пацієнт',
  'arrivals.colBranch': 'Філія',
  'arrivals.colUrgency': 'Терміновість',
  'arrivals.colStatus': 'Стан',
  'arrivals.colWho': 'Хто взяв',
  'arrivals.colReaction': 'Реакція',
  'arrivals.colNotified': 'Сповіщено',
  'arrivals.noUrgency': 'Прийшов пацієнт',
  'arrivals.take': 'Беру',
  'arrivals.taken': 'Пацієнт ваш',
  'arrivals.min': '{n} хв',
  'arrivals.noDuty': 'Нікого на зміні — сповіщено резерв',
  'arrivals.unmapped': 'Лікарів на зміні без користувача Bridge: {n}',
  'arrivals.status.open': 'Чекає',
  'arrivals.status.taken': 'Взяли',
  'arrivals.status.assigned': 'Лікаря призначено',
  'arrivals.status.cancelled': 'Скасовано',
  'arrivals.status.expired': 'Ніхто не взяв',
  'arrivals.detail': 'Надходження',
  'arrivals.recipients': 'Кого сповіщено',
  'arrivals.notSent': 'не надіслано (тіньовий режим)',
  'arrivals.quiet': 'тихі години: лише в застосунку',
  'arrivals.reason.duty_enote': 'на зміні (графік Enote)',
  'arrivals.reason.duty_bridge': 'на зміні (Bridge)',
  'arrivals.reason.fixed': 'фіксований список',
  'arrivals.reason.role': 'за роллю',
  'arrivals.reason.fallback': 'резерв (нікого на зміні)',
  'arrivals.reason.always': 'завжди',
  'arrivals.reason.repeat': 'повтор',
  'arrivals.reason.escalation': 'ескалація',
  'arrivals.reason.urgency': 'зміна терміновості',
  'arrivals.reason.taken': 'повідомлення «взяв»',
  'arrivals.reason.closed': 'лікаря призначено',
  'arrivals.openJourney': 'Відкрити візит',
  'arrivals.statArrivals': 'Надходжень',
  'arrivals.statPerDay': 'на день',
  'arrivals.statMedian': 'Медіана реакції',
  'arrivals.statWithin': 'Взяли за {n} хв',
  'arrivals.statUrgency': 'З терміновістю',
  'arrivals.statNoDuty': 'Без чергового',
  'arrivals.statRecipients': 'Отримувачів у середньому',
  'arrivals.statEscalated': 'Ескалацій',
  'arrivals.statExpired': 'Ніхто не взяв',
  'arrivals.save': 'Зберегти',
  'arrivals.saved': 'Налаштування збережено',
  'arrivals.branch': 'Філія',
  'arrivals.mode': 'Режим',
  'arrivals.mode.off': 'Вимкнено',
  'arrivals.mode.shadow': 'Тіньовий (лише запис)',
  'arrivals.mode.on': 'Увімкнено',
  'arrivals.recipientsMode': 'Кого сповіщати',
  'arrivals.recip.on_duty': 'Лікарів на зміні',
  'arrivals.recip.fixed': 'Фіксований список',
  'arrivals.recip.role': 'За ролями',
  'arrivals.fixedUsers': 'Люди (фіксований список)',
  'arrivals.roles': 'Ролі',
  'arrivals.alwaysUsers': 'Завжди сповіщати (завідувач, адміністратор)',
  'arrivals.fallbackUsers': 'Якщо нікого на зміні — люди',
  'arrivals.fallbackRoles': 'Якщо нікого на зміні — ролі',
  'arrivals.escalationUsers': 'Ескалація — кому (завідувач)',
  'arrivals.escalationRoles': 'Ескалація — ролі, якщо людей не вказано',
  'arrivals.dutyNow': 'Зараз на зміні в Enote: {on}, без користувача Bridge: {unmapped}; сповіщення отримали б: {reach}',
  'arrivals.generic': '«Загальні» лікарі (означають «лікаря ще немає»)',
  'arrivals.genericHint': 'Імена співробітників Enote. Поруч — скільки записів без запису мали цього лікаря за 60 днів.',
  'arrivals.addGeneric': 'Додати',
  'arrivals.sources': 'Джерела',
  'arrivals.srcAppointments': 'Записи (попередній запис Enote)',
  'arrivals.srcVisits': 'Візити, відкриті на «загального» лікаря',
  'arrivals.walkInOnly': 'Лише «без запису»',
  'arrivals.freshness': 'Вікно свіжості, хв',
  'arrivals.freshnessHint': 'Запис, зроблений давніше, вже не сповіщається (затримка синхронізації з Enote — 5–15 хв).',
  'arrivals.levels': 'Рівні терміновості',
  'arrivals.levelKey': 'Ключ',
  'arrivals.levelLabel': 'Назва',
  'arrivals.levelColor': 'Колір',
  'arrivals.levelUrgent': 'Термінове',
  'arrivals.levelChannels': 'Канали (крім застосунку)',
  'arrivals.levelRepeat': 'Повтор, хв',
  'arrivals.levelMaxRepeats': 'Повторів',
  'arrivals.levelEscalate': 'Ескалація через, хв',
  'arrivals.rules': 'Як визначати терміновість',
  'arrivals.rulesHint': 'Перше правило, що спрацювало, задає рівень. Текст — без урахування регістру, варіанти через «|».',
  'arrivals.ruleSource': 'Джерело',
  'arrivals.ruleMatch': 'Текст / колір',
  'arrivals.ruleLevel': 'Рівень',
  'arrivals.src.comment': 'Коментар запису',
  'arrivals.src.visit_kind': 'Вид прийому',
  'arrivals.src.triage': 'Тріаж кол-центру',
  'arrivals.addRule': 'Додати правило',
  'arrivals.remove': 'Прибрати',
  'arrivals.quietHours': 'Тихі години',
  'arrivals.quietHint': 'У тихі години рівні, яких немає в списку, приходять лише в застосунок (без Telegram і push).',
  'arrivals.quietLevels': 'Рівні, що звучать і в тихі години',
  'arrivals.from': 'з',
  'arrivals.to': 'до',
  'arrivals.followups': 'Повідомлення',
  'arrivals.notifyUrgency': 'Повідомляти, коли терміновість з’явилась або змінилась',
  'arrivals.notifyTaken': 'Повідомляти інших «Пацієнта взяв лікар X»',
  'arrivals.expire': 'Закривати як «ніхто не взяв» через, хв',
  'arrivals.target': 'Ціль реакції, хв',
  'arrivals.previewTitle': 'Що було б за останні дні',
  'arrivals.previewHint': 'Реальні записи на «загального» лікаря, прогнані через поточні налаштування (незалежно від режиму). Нічого не надсилається.',
  'arrivals.pvArrivals': 'Надходжень',
  'arrivals.pvUrgency': 'З терміновістю',
  'arrivals.pvRecipients': 'Отримувачів на надходження',
  'arrivals.pvNoDuty': 'Без досяжного чергового',
  'arrivals.pvNoShift': 'Нікого в графіку Enote',
  'arrivals.pvOnDuty': 'Лікарів на зміні (Enote)',
  'arrivals.pvUnmapped': 'з них без користувача Bridge',
  'arrivals.pvRoles': 'Ролі отримувачів',
  'arrivals.channel.telegram': 'Telegram',
  'arrivals.channel.push': 'Push (застосунок)',
  'arrivals.channel.webpush': 'Web Push',
  'arrivals.channel.email': 'Email',
}

export const arrivalsEn: { [K in keyof typeof arrivalsUk]?: string } = {
  'nav.arrivals': 'Patient arrivals',
  'arrivals.subtitle': 'A walk-in registered to the generic doctor alerts the doctors on duty; they press «Take»',
  'arrivals.tabLog': 'Log',
  'arrivals.tabStats': 'Reaction time',
  'arrivals.tabSettings': 'Settings',
  'arrivals.tabPreview': 'Dry run',
  'arrivals.offBanner': 'Alerts are off for every branch. Enable a branch in Settings (start with shadow mode).',
  'arrivals.take': 'Take',
  'arrivals.save': 'Save',
  'arrivals.mode.off': 'Off',
  'arrivals.mode.shadow': 'Shadow (record only)',
  'arrivals.mode.on': 'On',
}
